import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { Form, Formik } from "formik";
import { useState } from "react";
import * as yup from "yup";

import useAPI from "../../../../api/hooks/useAPI";
import { integrationKeys } from "../../../../api/queryKeys";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";
import { Toast } from "../../../../components/Toast";

const PanoraysConnectForm = () => {
  const [showSecret, setShowSecret] = useState(false);
  const [loading, setLoading] = useState(false);
  const queryClient = useQueryClient();
  const { registerPanoraysIntegration } = useAPI();

  const handleClickShowSecret = () => setShowSecret(!showSecret);
  const handleMouseDownSecret = () => setShowSecret(!showSecret);

  const formInitialValues = {
    api_token: "",
  };

  const formCheckoutSchema = yup.object().shape({
    api_token: yup.string().required("required"),
  });

  const handleFormSubmit = (values) => {
    setLoading(true);
    registerPanoraysIntegration(values.api_token.trim())
      .then((response) => {
        queryClient.invalidateQueries({
          queryKey: integrationKeys.all,
        });
        Toast.success("Panorays integration successful");
      })
      .catch((error) => {
        if (error.response) {
          Toast.error(`Something went wrong: ${error.response.data.detail}`);
        } else {
          Toast.error("An error occurred while processing the request.");
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Formik
      onSubmit={handleFormSubmit}
      initialValues={formInitialValues}
      validationSchema={formCheckoutSchema}
    >
      {({
        values,
        errors,
        touched,
        handleBlur,
        handleChange,
        handleSubmit,
      }) => (
        <Form>
          <Box display="flex" flexDirection="column" alignItems="center">
            <TextField
              fullWidth
              variant="filled"
              name="api_token"
              label="API Token"
              value={values.api_token}
              onBlur={handleBlur}
              onChange={handleChange}
              autoComplete="off"
              type={showSecret ? "text" : "password"}
              error={!!touched.api_token && !!errors.api_token}
              helperText={
                touched.api_token && errors.api_token
                  ? String(errors.api_token)
                  : ""
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle token visibility"
                      onClick={handleClickShowSecret}
                      onMouseDown={handleMouseDownSecret}
                    >
                      {showSecret ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              style={{ width: "700px" }}
            />
          </Box>
          <PrimaryButton
            sx={{ width: "100px", marginTop: "16px" }}
            type="submit"
          >
            Connect
          </PrimaryButton>
        </Form>
      )}
    </Formik>
  );
};

export default PanoraysConnectForm;
